import React, { useState, useCallback, useEffect } from 'react';
import ProductsService from '@/services/ProductsService';

export default function useProductsData() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [adding, setAdding] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [removing, setRemoving] = useState(false);
  const [error, setError] = useState(null);

  const loadData = useCallback(async () => {
    setLoading(true);
    setError(null);

    const result = await ProductsService.getAllProducts();

    if (result.error) {
      setData([]);
      setError(result.error);
    } else {
      setData(result.data);
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const clearError = useCallback(() => { setError(null); }, []);

  const add = async (product) => {
    setAdding(true);
    setError(null);

    const result = await ProductsService.addProduct(product);

    if (result.error) {
      setError(result.error);
      setAdding(false);
      return false;
    }

    await loadData();
    setAdding(false);
    return true;
  };

  const update = async (id, updatedProduct) => {
    setUpdating(true);
    setError(null);

    const result = await ProductsService.updateProduct(id, updatedProduct);
    if (result.error) {
      setError(result.error);
      setUpdating(false);
      return false;
    }

    await loadData();
    setUpdating(false);
    return true;
  };

  const remove = async (id) => {
    setRemoving(true);
    setError(null);

    const result = await ProductsService.deleteProduct(id);
    if (result.error) {
      setError(result.error);
      setRemoving(false);
      return false;
    }

    await loadData();
    setRemoving(false);
    return true;
  };

  return {
    data,
    loading,
    adding,
    updating,
    removing,
    error,
    setLoading,
    setAdding,
    setUpdating,
    setRemoving,
    setError,

    loadData,
    add,
    update,
    remove,
    clearError,
  };
}
